import React, { PureComponent } from 'react';
import Literal from 'components/Literal'; // FIXME Please use getLiteral here
import { getLiteral } from 'utils/getLiteral';
import Select from 'components/Select';
import { Bool, Text } from 'components/Fields';
import DatePicker from 'components/Date';
import { TYPE_INT, TYPE_FLOAT, TYPE_DATE, TYPE_BOOLEAN, TYPE_REGULAR } from 'constants/FieldTypes';
import { ArrowLeft, ArrowBidirectional } from 'components/SvgIcons';
import './style.scss';

class FieldsMappingLine extends PureComponent {
    state = {
        selectValue: {
            type: '',
            label: '',
            mandatory: false,
            picklistValues: [],
            value: null,
            defaultValue: '',
        },
    };

    constructor(props) {
        super(props);
    }

    componentDidMount() {
        const { fieldConfig, selectFields, fieldType, field, getFmValuelist, outgoing } =
            this.props;
        const selectKey = outgoing ? 'forcemanagerField' : 'externalField';
        const selectValue = selectFields[fieldType].obj[fieldConfig[selectKey]];
        if (selectValue) {
            if (selectValue.type === 'picklist') {
                let options = [];
                if (selectValue.value === 'custom') {
                    options = fmValueList;
                } else {
                    options = selectValue.picklistValues;
                }
                options.forEach((option) => {
                    if (fieldConfig.defaultValue === option.value)
                        selectValue.defaultValue = option;
                });
            } else {
                selectValue.defaultValue = fieldConfig.defaultValue;
            }
            this.setState({ selectValue: selectValue });
        }
        field.LinkedTable && getFmValuelist(field.LinkedTable);
    }

    handleSelChange = (newValue, actionMeta) => {
        const { onFieldsSelChange } = this.props;
        if (actionMeta.action === 'clear') {
            this.setState({
                selectValue: {
                    ...newValue,
                    defaultValue: null,
                },
            });
        } else {
            this.setState({ selectValue: newValue });
        }
        let oldValue = this.state.selectValue ? this.state.selectValue.value : undefined;
        onFieldsSelChange(oldValue, newValue, actionMeta);
    };

    handleDefaultChange = (newValue, actionMeta) => {
        const { onFieldDefaultChange } = this.props;
        this.setState({
            selectValue: {
                ...this.state.selectValue,
                defaultValue: newValue,
            },
        });
        onFieldDefaultChange(newValue, actionMeta);
    };

    renderDefault() {
        const { fmValueList, stepperAlertErrorsFm } = this.props;
        const { selectValue } = this.state;
        let input;
        let mandatory = '';
        if (selectValue) {
            switch (selectValue.type) {
                case 'boolean':
                    input = <Bool />;
                    break;
                case 'int':
                case 'double':
                case 'decimal':
                case 'string':
                case 'reference':
                case 'email':
                case 'phone':
                case 'textarea':
                    input = (
                        <Text
                            value={selectValue.defaultValue}
                            onChange={this.handleDefaultChange}
                            error={
                                (stepperAlertErrorsFm && stepperAlertErrorsFm.defaultValue) || false
                            }
                        />
                    );
                    break;
                case 'date':
                    input = <DatePicker />;
                    break;
                case 'picklist':
                    let options = [];
                    if (selectValue.value === 'custom') {
                        options = fmValueList;
                    } else {
                        options = selectValue.picklistValues;
                    }
                    input = (
                        <Select
                            value={selectValue.defaultValue}
                            name="default-select"
                            options={options}
                            onChange={this.handleDefaultChange}
                            placeholder={getLiteral('placeholder_valuelist_field')}
                            error={
                                (stepperAlertErrorsFm && stepperAlertErrorsFm.defaultValue) || false
                            }
                            isClearable
                        />
                    );
                    break;
                default:
                    break;
            }
        }

        return <div className={'fields-mapping-line-default' + mandatory}>{input}</div>;
    }
    renderArrow() {
        const { bidirectional } = this.props;
        if (bidirectional) {
            return <ArrowBidirectional />;
        } else {
            return <ArrowLeft />;
        }
    }

    render() {
        const {
            field,
            fieldConfig,
            selectFields,
            fieldType,
            literals,
            stepperAlertErrorsFm,
            stepperAlertErrorsExt,
            bidirectional,
            outgoing,
        } = this.props;
        const selectKey = outgoing ? 'forcemanagerField' : 'externalField';
        const key = outgoing ? field.value : field.RestAPIName;
        const value = selectFields[fieldType].obj[fieldConfig[selectKey]];
        let type;
        if (field.FMType === TYPE_REGULAR) {
            switch (field.Type) {
                case TYPE_INT:
                    type = 'int';
                    break;
                case TYPE_FLOAT:
                    type = 'double';
                    break;
                case TYPE_DATE:
                    type = 'date';
                    break;
                case TYPE_BOOLEAN:
                    type = 'boolean';
                default:
                    type = 'string';
                    break;
            }
        } else {
            type = 'picklist';
        }
        const customOption = {
            options: [
                {
                    label: getLiteral(
                        literals['label_integration_custom_vale'] ||
                            'label_integration_custom_vale',
                    ),
                    value: 'custom',
                    type: type,
                    mandatory: false,
                    picklistValues: [],
                },
            ],
        };
        const options = {
            options: selectFields[fieldType].arr || selectFields['noList'].arr,
        };
        let lineErrorClass =
            (stepperAlertErrorsFm &&
                (stepperAlertErrorsFm.selectValue || stepperAlertErrorsFm.defaultValue)) ||
            stepperAlertErrorsExt
                ? 'error'
                : '';
        const fmFieldLiteral = field.Literal !== '' ? field.Literal : field.RestAPIName;
        const fieldLiteral = outgoing ? field.label : fmFieldLiteral;
        return (
            <div className="fields-mapping-line">
                <div className={`fields-mapping-line-fm ${lineErrorClass}`}>
                    <Literal literal={fieldLiteral} />
                    <span className="fields-mapping-line-fm-key"> ({key})</span>
                    <span className="mandatory">
                        {(bidirectional || (!bidirectional && !outgoing)) &&
                        fieldConfig &&
                        fieldConfig.mandatory
                            ? '*'
                            : ''}
                    </span>
                </div>
                <div className="fields-mapping-line-arrows">{this.renderArrow()}</div>
                <div className="fields-mapping-line-ext">
                    <Select
                        className="ext-field-select"
                        value={value}
                        name="ext-select"
                        options={[customOption, options]}
                        onChange={this.handleSelChange}
                        placeholder={getLiteral('placeholder_valuelist_field')}
                        error={(stepperAlertErrorsFm && stepperAlertErrorsFm.selectValue) || false}
                        isClearable
                    />
                </div>
                {this.renderDefault()}
            </div>
        );
    }
}

export default FieldsMappingLine;
